angular.module 'app'
.controller 'WechatKeyWordCtrl', ($scope, $http, $state, $uibModalInstance, config, Storage, FileUploader, growl, data) ->
  $scope.ui =
    url: data.url
    token: data.token

  $scope.cancel = ->
    $uibModalInstance.dismiss 'Cancel'
